// | ------------------------------------------------------------------------
// | Components - Item Carousel
// | ------------------------------------------------------------------------

//? https://splidejs.com/
import Splide from "@splidejs/splide";

//? https://github.com/yowainwright/shave
import shave from "shave"; 

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var itemsCarousel = document.querySelector(".item-carousel");
  var btnNext = document.querySelector(".item-next-btn");
  var btnPrev = document.querySelector(".item-prev-btn");


  if (itemsCarousel) {

    var itemCarousel = new Splide(".item-carousel", {
      type: "loop",
      perPage: 5,
      perMove: 1,
      pagination: false,
      gap: "var(--global-spacing)",
      arrows: false,
      breakpoints: {
        1700: {
          perPage: 4,
        },
        1400: {
          perPage: 3,
        },
        900: {
          perPage: 2,
        },
        575: {
          perPage: 2,
        },
      },
    });

    itemCarousel.mount();

    btnNext.addEventListener("click", (e) => {
      itemCarousel.go("+1");
    });

    btnPrev.addEventListener("click", (e) => {
      itemCarousel.go("-1");
    });


    // Shave titles if they get too big
    var projectItem = document.querySelector(".project-item");
    var blogItem = document.querySelector(".blog-item");

    if(projectItem){
      shave(".project-item .project-item-title", 100, {});
    }

    if(blogItem){
      shave(".blog-item h3", 150, {});
    }    


    //? Uncomment the below to get the carousel to scroll on mousewheel
    //* Will need tweaking if required as it is a bit too sensitive with current settings

    /*
    var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

    function preventDefault(e) {
      e.preventDefault();
    }

    function preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
      }
    }

    // modern Chrome requires { passive: false } when adding event
    var supportsPassive = false;
    try {
      window.addEventListener(
        "test",
        null,
        Object.defineProperty({}, "passive", {
          get: function () {
            supportsPassive = true;
          },
        })
      );
    } catch (e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent =
      "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";

    // call this to Disable
    function disableScroll() {
      window.addEventListener("DOMMouseScroll", preventDefault, false); // older FF
      window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
      window.addEventListener("touchmove", preventDefault, wheelOpt); // mobile
      window.addEventListener("keydown", preventDefaultForScrollKeys, false);
    }

    // call this to Enable
    function enableScroll() {
      window.removeEventListener("DOMMouseScroll", preventDefault, false);
      window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
      window.removeEventListener("touchmove", preventDefault, wheelOpt);
      window.removeEventListener("keydown", preventDefaultForScrollKeys, false);
    }

    var isOver = false;

    homeNewsCarousel.addEventListener("mouseleave", function (event) {
      console.log("is not over carousel");
      isOver = false;
      enableScroll();
    });

    homeNewsCarousel.addEventListener("mouseenter", function (event) {
      disableScroll();
      console.log("is over carousel");
      isOver = true;

      document.addEventListener("wheel", (e) => {
        if (isOver === true) {
          const { deltaY } = e;
          homeNews.go(deltaY > 0 ? ">" : "<");
        } else {
          // do nothing...
        }
      });
    });
    */
  }
});
